// extracted by mini-css-extract-plugin
export default {"section":"DataTables_section__agabL","tableRow":"DataTables_tableRow__b7jAm"};